export default {
  components: {},
  props: {},
  data() {
    return {
      scenesSettings_show: true,
      starrySkyBackgroundShow: true,
      sunShadowShow: false,
      atmosphericRenderingShow: true,
      DayAndNightShadowsShow: false,
      isFold: false,
    };
  },
  mounted() {},
  methods: {
    scenesSettingsBox_close() {
      this.$emit("scenesSettingsBox_close");
    },
    starrySkyBackground() {
      if (this.starrySkyBackgroundShow) {
        this.$GLOBAL.map.setSceneOptions({
          showSkyBox: true,
        });
        //this.$GLOBAL.map.scene.skyBox.show =true;

        this.$message({
          message: "已开启 星空背景。",
          type: "success",
          offset: 100,
          showClose: true,
          duration: 1600,
        });
      } else {
        this.$GLOBAL.map.setSceneOptions({
          showSkyBox: false,
        });
        //this.$GLOBAL.map.scene.skyBox.show =false;

        this.$message({
          message: "已关闭 星空背景。",
          type: "success",
          offset: 100,
          showClose: true,
          duration: 1600,
        });
      }
      //this.starrySkyBackgroundShow = !this.starrySkyBackgroundShow;
    },
    sunShadow() {
      if (this.sunShadowShow) {
        this.$GLOBAL.map.setSceneOptions({
          shadows: true,
        });
        //this.$GLOBAL.map.scene.globe.enableLighting=true;
        this.$message({
          message: "已开启 日照阴影。选中模型效果更明显哦~",
          type: "success",
          offset: 100,
          showClose: true,
          duration: 1600,
        });
      } else {
        this.$GLOBAL.map.setSceneOptions({
          shadows: false,
        });
        //this.$GLOBAL.map.scene.globe.enableLighting=false;
        this.$message({
          message: "已关闭 日照阴影。选中模型效果更明显哦~",
          type: "success",
          offset: 100,
          showClose: true,
          duration: 1600,
        });
      }
      //this.sunShadowShow = !this.sunShadowShow;
    },
    DayAndNightShadows() {
      if (this.DayAndNightShadowsShow) {
        this.$GLOBAL.map.scene.globe.enableLighting = true;
        this.$message({
          message: "已开启 昼夜区域。",
          type: "success",
          offset: 100,
          showClose: true,
          duration: 1600,
        });
      } else {
        this.$GLOBAL.map.scene.globe.enableLighting = false;
        this.$message({
          message: "已关闭 昼夜区域。",
          type: "success",
          offset: 100,
          showClose: true,
          duration: 1600,
        });
      }
      //this.sunShadowShow = !this.sunShadowShow;
    },
    atmosphericRendering() {
      window.sessionStorage.setItem(
        "atmosphericRenderingShow",
        this.atmosphericRenderingShow
      );
      if (this.atmosphericRenderingShow) {
        // this.$GLOBAL.map.setSceneOptions({showSkyAtmosphere:true});
        this.$GLOBAL.map.scene.showSkyAtmosphere = true;
        this.$GLOBAL.map.scene.skyAtmosphere.show = true;
        this.$GLOBAL.map.scene.globe.showGroundAtmosphere = true;
        this.$message({
          message: "已开启 大气渲染。",
          type: "success",
          offset: 100,
          showClose: true,
          duration: 1600,
        });
      } else {
        this.$GLOBAL.map.scene.showSkyAtmosphere = false;
        this.$GLOBAL.map.scene.skyAtmosphere.show = false;

        // console.log(this.$GLOBAL.map.scene.showSkyAtmosphere);
        // let that=this;
        // setTimeout(function(){
        // 	console.log(that.$GLOBAL.map.scene.showSkyAtmosphere);
        // 	console.log(111111111)
        // },1000)
        this.$GLOBAL.map.scene.globe.showGroundAtmosphere = false;
        this.$message({
          message: "已关闭 大气渲染。",
          type: "success",
          offset: 100,
          showClose: true,
          duration: 1600,
        });
      }
      //this.atmosphericRenderingShow = !this.atmosphericRenderingShow;
    },
  },
  watch: {},
  destroyed() {
    // this.$GLOBAL.map.setSceneOptions({showSkyBox:false});
    // this.$GLOBAL.map.setSceneOptions({shadows:false});

    this.$GLOBAL.map.setSceneOptions({
      showSkyBox: true,
    });
    //this.$GLOBAL.map.scene.skyBox.show =true;

    this.$GLOBAL.map.setSceneOptions({
      shadows: false,
    });

    this.$GLOBAL.map.scene.globe.enableLighting = false;

    this.$GLOBAL.map.scene.showSkyAtmosphere = true;
    this.$GLOBAL.map.scene.skyAtmosphere.show = true;
    this.$GLOBAL.map.scene.globe.showGroundAtmosphere = true;
    window.sessionStorage.setItem("atmosphericRenderingShow", true);

    //默认开启深度检测
  },
};
